export const isLoaded = (result)=>result != 'loading' && result != 'error';
